/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
import { Typography } from '@material-ui/core';
import _ from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CountyContext from '../../contexts/CountyContext';
import StoryContext from '../../contexts/StoryContext';
import { composeWhereClause } from '../../modules/data';
import { rdsTabulate } from '../../modules/rds';
import states, { stateFIPS } from '../../modules/states';
import { toPercent } from '../../modules/text';
import BarChart from '../BarChart';
import { getMedianHouseholdIncome } from './data';

function AveragePriceByChildAge({ height = 300, width }) {
  const { stateCode } = useParams();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  const { countyCode, county } = useContext(CountyContext);
  const [data, setData] = useState([]);
  const { primaryColor, secondaryColor } = useContext(StoryContext);

  useEffect(() => {
    setError(null);
    function getRatesByAgeGroup() {
      let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]}`;
      whereClause += composeWhereClause({});

      if (countyCode) {
        whereClause += ` AND county_fips=${countyCode}`;
      }

      return rdsTabulate('ccdc', 'county_setting_group_rate_annual', {
        dims: 'age_group',
        measure: 'average_rate:AVG(rate)',
        where: whereClause,
        format: 'amcharts',
        inject: true,
      }, true);
    }

    // function getMedianHouseholdIncome() {
    //   let dataProduct = 'acs_sams_state_wide';
    //   let where = `state_fips=${stateFIPS[stateCode.toUpperCase()]}`;
    //   if (countyCode) {
    //     dataProduct = 'acs_sams_county_wide';
    //     where += ` AND county_fips=${countyCode} AND (county_suppressed=0 OR county_suppressed=NULL)`;
    //   }
    //   return rdsSelect('3rdparty', dataProduct, {
    //     cols: 'inc_hh,inc_fam_married,inc_fam_nospouse',
    //     where,
    //     format: 'amcharts',
    //     inject: false,
    //   }, true);
    // }

    if (stateCode && states[stateCode.toUpperCase()]) {
      Promise.all([getRatesByAgeGroup(), getMedianHouseholdIncome(stateCode, countyCode)])
        .then((responses) => {
          const rates = responses[0].parsedBody.dataProvider;
          const infants = _.find(rates, { age_group: 'Infants' });
          const toddlers = _.find(rates, { age_group: 'Toddlers' });
          infants.age_group = 'Infants and Toddlers';
          infants.average_rate = (infants.average_rate + toddlers.average_rate) / 2;
          _.pull(rates, toddlers);
          const incomes = responses[1].parsedBody.dataProvider[0];
          const d = rates.map((r) => {
            const dataItem = { ...r };
            dataItem['Married-couple families'] = r.average_rate / incomes.inc_fam_married;
            dataItem['Single-parent families'] = r.average_rate / incomes.inc_fam_nospouse;
            return dataItem;
          });
          setData(d);
        })
        .catch((err) => {
          setError(err);
        })
        .finally(() => {
          setReady(true);
        });
    }
  }, [stateCode, countyCode]);

  const keys = ['Married-couple families', 'Single-parent families'];
  const groupKey = 'age_group';

  let title = 'Child Age';
  if (county) {
    title += ` - ${county} County`;
  }

  // const tooltipTemplate = `<b>#VALUE#</b> of the household income for <b>#FAMILY#</b> goes to pay for <b>#GROUPING#</b> child care.
  // `;

  const formatterFunction = function formatterFunction(payload) {
    if (payload.value) {
      return `<b>${toPercent(payload.value)}</b> of the household income for <b>${payload.dataKey.toLowerCase()}</b> 
    goes to pay for <b>${payload.payload.age_group.toLowerCase()}</b> child care.`;
    }
    return 'Insufficient sample size';
  };

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      <BarChart
        valueFormatter={toPercent}
        formatterFunction={formatterFunction}
        height={height}
        width={width}
        ready={ready}
        data={data}
        keys={keys}
        groupKey={groupKey}
        title={title}
        colors={[primaryColor, secondaryColor]}
      />
    </>
  );
}

export default AveragePriceByChildAge;
